import React from 'react'
import './SelectCard.css'

type OptionProp = {
  id: number
  value: string
  label: string
}

type SelectCardProps = {
  selected?: number
  options: Array<OptionProp>
  onChange?: (value: any) => any
}

function SelectCard({
  selected,
  options,
  onChange = () => {}
}: SelectCardProps) {
  return (
    <div className='cocunat-SelectCard'>
      {options.map((option) => (
        <button
          onClick={() => onChange(option)}
          key={option.id}
          value={option.value}
          className={selected === option.id ? 'cocunat-SelectCard_active' : ''}
        >
          {option.label}
        </button>
      ))}
    </div>
  )
}

export default SelectCard
